import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaginatorPosition } from './simple-paginator.enum';

@Component({
  selector: 'app-wellby-simple-paginator',
  templateUrl: './simple-paginator.component.html',
  styleUrls: ['./simple-paginator.component.scss'],
})
export class SimplePaginatorComponent implements OnInit {
  @Output() prevEmit = new EventEmitter<number>();

  @Output() nextEmit = new EventEmitter<number>();

  @Input()
  disableNext = false;

  @Input()
  disablePrev = true;

  @Input()
  position: PaginatorPosition = PaginatorPosition.CENTER;

  @Input()
  paginationClickedCount = 1;

  constructor() {}

  ngOnInit(): void {}

  prevPage(): void {
    this.paginationClickedCount--;
    this.prevEmit.emit(this.paginationClickedCount);
  }

  nextPage(): void {
    this.paginationClickedCount++;
    this.nextEmit.emit(this.paginationClickedCount);
  }
}
